import { Injectable } from "@angular/core";
import { Http, Response, Headers, RequestOptions,RequestOptionsArgs } from '@angular/http';
import { Router } from '@angular/router';
//import { LoadingService } from '../loading-spinner/loading.service';
import { Observable } from 'rxjs/Rx';
import CONFIG from '../config';
import { HttpEvent, HttpEventType } from '@angular/common/http';
//import { map } from 'rxjs/operators';
// import 'rxjs/add/operator/map';
 import { map } from "rxjs/operators";;
// import 'rxjs/add/operator/take';

@Injectable({
    providedIn:'root'
})
export class AuthService
{
    public loggedIn:boolean;
    public LoginType:String=localStorage.getItem('logintype')|| sessionStorage.getItem('logintype');
    public TaskNumber:String=localStorage.getItem('TaskNumber')|| sessionStorage.getItem('TaskNumber');
    public token:string=localStorage.getItem('token')||sessionStorage.getItem('token');
    public UserName:string=localStorage.getItem('UserName')||sessionStorage.getItem('UserName');
    public BankName:string=localStorage.getItem('BankName')||sessionStorage.getItem('BankName');
    //public UserName:string =localStorage.getItem('TaskNumber')||sessionStorage.getItem('TaskNumber');
    public TransactionNo:string =localStorage.getItem('TransactionNo')||sessionStorage.getItem('TransactionNo');
    public bankcodevalue:string =localStorage.getItem('bankcodevalue')||sessionStorage.getItem('bankcodevalue');
   
    constructor(private _http:Http,private _router:Router,//private //_loadingService:LoadingService
        )
    {

    }

    login(loginData):Observable <any>
    {
           // this._loadingService.show();
            const body=JSON.stringify(loginData);
            const headers=new Headers({
                'Content-Type':'application/json',
                'Accept':'application/json'
            });

            const options=new RequestOptions({headers: headers});
           // console.log(loginData);
           // console.log(body);
            return this._http.post(CONFIG.loginApiUrlBase,body,options)
            .map(response => {
               // console.log(response);
                return response.json();})
            .catch(this.handleError)
            .finally(() => {
                
               // this._loadingService.hide();
            });
    }

    logout() 
        {
      //  this._loadingService.show();
        this.loggedIn = false;    
        console.log(this.LoginType)  ;  
        //this._http.get(CONFIG.loginApiUrlBase)
       this._http.get(CONFIG.logoutApiUrlBase+ '/' + this.TaskNumber+ '/' + this.LoginType)
            .subscribe(response => {
                //this._loadingService.hide();
                if (localStorage.getItem('token') !== null) 
                {
                    localStorage.removeItem('TaskNumber');
                    localStorage.removeItem('token');
                    localStorage.removeItem('TaskNumber');
                }
                if (sessionStorage.getItem('token') !== null) 
                {
                    localStorage.removeItem('TaskNumber');
                    sessionStorage.removeItem('token');
                    localStorage.removeItem('TaskNumber');
                }

                //remove locally cached identity variables
                this.token = null;
                this.loggedIn = false;
                this.TaskNumber = null;

                this._router.navigate(['/']);
            },
            error => 
            {
                this.handleError(error);
            },
            () => {
                //this._loadingService.hide();
            });
        }


    private handleError(error) {
        const errMsg = error.message || 'Server error';
        return Observable.throw(error);
    }
}